module.exports = __webpack_public_path__ + "img/dashboard.b6076989.svg";